import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Action, State, StateContext } from "@ngxs/store";
import { GetYearList, GetYearListFail, GetYearListSuccess } from "./years.actions";
import { createRequestAction, RequestState } from "ngxs-requests-plugin";
import { environment } from "../../../../environments/environment";
import { AppConfigService } from "../../services/app-config.service";

import { statusCodeErrorHandler } from "../../../shared/utils/status-code-error-handler";

export interface YearsStateModel {
  years: number[],
}

@RequestState('getYearList')
@Injectable()
export class GetYearListRequestState {}

@State<YearsStateModel>({
  name: 'years',
  defaults: {
    years: null
  }
})
@Injectable()
export class YearsState {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
  ) {}

  @Action(GetYearList)
  getYearList(
    { dispatch }: StateContext<YearsStateModel>
  ) {
    const params = new HttpParams({ fromObject: {dbName: this.appConfig.dbName, dbVersion: "latest"} });
    const request = this.http.get(environment.api + 'db/meta/year_list', {params});

    return dispatch(
      createRequestAction({
        request,
        state: GetYearListRequestState,
        successAction: GetYearListSuccess,
        failAction: GetYearListFail
      })
    );
  }

  @Action(GetYearListSuccess)
  getYearListSuccess(
    { patchState }: StateContext<YearsStateModel>,
    { payload: response }: GetYearListSuccess
  ) {
    patchState({years: response.content});
  }

  @Action(GetYearListFail)
  getVariablesTreeFail(
    { dispatch }: StateContext<YearsStateModel>,
    { payload: error }: GetYearListFail
  ) {
    statusCodeErrorHandler(error, dispatch)
  }
}
